
<template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <div class="left-side-board">
          <img class="logo" src="@/assets/Cogneetiv.png" />
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="12" justify="center" align="center">
        <div>
          <img src="@/assets/circle.png" class="voice" />
          <GoogleLogin
            :params="params"
            :renderParams="renderParams"
            :onSuccess="onSuccess"
            :onFailure="onFailure"
          ></GoogleLogin>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
// import Wave from "@/components/Wave.vue";
import GoogleLogin from "vue-google-login";
export default {
  name: "login",
  data() {
    return {
      // client_id is the only required property but you can add several more params, full list down bellow on the Auth api section
      params: {
        client_id:
          "292320827989-nou250q4tjpk0j0h4j5poodgai5km88f.apps.googleusercontent.com",
        scope: "https://mail.google.com/",
      },
      // only needed if you want to render the button with the google ui
      renderParams: {
        width: 250,
        height: 50,
        longtitle: true,
      },
    };
  },
  mounted() {},
  methods: {
    onSuccess(googleUser) {
      console.log(googleUser);
      localStorage.setItem("currentUser", JSON.stringify(googleUser));
      this.$router.push({ name: "dailybriefing" });
    },
    onFailure(error) {
      console.log(error);
    },
  },
  components: {
    GoogleLogin,
  },
};
</script>

<style>
.ml-20 {
  margin-left: 20px;
}
.logo {
  width: 300px;
}
.left-side-board {
  text-align: center;
  margin: 50px auto;
}
.voice {
  width: 370px;
  margin-top: 30px;
}
h1 {
  color: #78b59c;
}
.form-margin {
  margin-top: 10%;
}
.abcRioButtonLightBlue {
  background: #78b59c !important;
  color: #fff !important;
  margin-top: 40px;
}
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .form-margin {
    margin-top: 0px !important;
  }
  .voice {
    width: 260px;
    margin-top: 10px;
  }
  .logo {
    width: 230px;
  }
}
</style>
